// Dependencies
require("webstrap/type");

// Styles
require("./tour-nav.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/tour-nav/index.js
 ** module id = 93
 ** module chunks = 0 1
 **/